import url from '@/shared/lib/url';
import viewer from '@/shared/utils/viewer';
import * as React from 'react';
import common from '@/shared/lib/common';
import useEvaluationStore from '@/entities/eval/model/eval-stnt.store';
import launcher from '@/shared/launcher';
import validate from '@/shared/lib/validate';
import datetime from '@/shared/utils/datetime';
import { lmsApi } from '@/shared/api/common';

const KvAssessmentView: React.FC<KvAssessmentViewProps> = (props) => {
    const {
        info,
        isPreview,
        isPeerReview,
        startTime,
        timTime,
        addSec,
        eventListener,
        useTime,
        endTime,
    } = props;
    const { publishInfo, sUserId, sUserNickName, gubun } = useEvaluationStore.getState();
    const evlId = info?.id ? info.id : -1;
    const setsId = info?.setsId ? info.setsId : -1;
    const evlNm = info?.evlNm ? info.evlNm : '';
    const rwdPoint = 10; // 평가 리원드 10 고정
    const isReportOpen = info?.rpOthbcAt == 'Y' ? 'Y' : 'N';
    const isInClass = info?.lesnEvalAt;
    const status = info?.tmprStrgAt === 'Y' ? 0 : info?.evlSttsCd;

    const setDate = () => {
        if (isPreview !== 'Y' && info?.lesnEvalAt !== 'Y') {
            // 수업시간 외 평가 학생 뷰어 시 마감일 설정
            return info?.evlCpDt || '';
        }
        return '';
    };

    const api_host = url.lCmsApi();
    const upload_api_host = import.meta.env.VITE_AIDT_URL_LMSAPI_VIEWER;
    const file_host = import.meta.env.VITE_URL_CMS;

    const isMath = props.subject != 'engl';
    const skin = isMath ? 'math' : 'english';

    const id = publishInfo.trgtId; //userInfo?.id
    const uid = sUserId; //userInfo?.uuid
    const name = sUserNickName;
    const getAppState = launcher.getAppState();

    const CurTime = sessionStorage.getItem('sCurrentTime') ?? '';
    const pCurTime = JSON.parse(CurTime);
    const [isInitTime, setIsInitTime] = React.useState(false);
    const timeRef = React.useRef('');

    const initTime = React.useCallback(async () => {
        timeRef.current = info?.timTime || '';
        if (isPreview === 'Y') {
            // 미리보기 시 설정 타이머
            timeRef.current = info?.timTime || '';
            setIsInitTime(true);
            return;
        }
        if (isInClass === 'Y') {
            if (startTime && timTime) {
                // 뷰어 진입 시 남은 시간

                lmsApi.getDateTime(); // 최대한 오차 줄이기 위해 뷰어 렌더링 직전에 서버 시간 동기화

                const isServerTime = !validate.isEmptyString(pCurTime);
                const currentTime = isServerTime ? pCurTime : datetime.getCurrTime();
                const remainingSec = datetime.getRemainingSeconds(
                    startTime,
                    timTime,
                    addSec,
                    currentTime
                );
                timeRef.current = datetime.getSecToTimecode(remainingSec);
            }
        } else {
            timeRef.current = datetime.getEvalHomeRemainTime(endTime, timTime, useTime);
        }

        setIsInitTime(true);
    }, [isPreview, startTime, timTime, addSec, endTime, useTime]);

    const kvAssessmentContainer = `
    <kv-assessment-container id="assessment"
        service_type='sbank'
        style="height: 100%; --kve-sans-serif: sans-serif;--kve-serif:serif;width: 100%;text-align: left !important;" 
        class="container" 
        userDiv="${gubun}"
        assessment_id="${evlId}"
        set_id="${setsId}"
        mode="slide"
        skin="${skin}"
        is_inclass="${isInClass ? isInClass : 'N'}"
        is_preview="${isPreview ? isPreview : 'N'}" 
        is_peer_review="${isPeerReview ? isPeerReview : 'N'}" 
        is_report_open="${isReportOpen ? isReportOpen : 'N'}"
        curri_title="${evlNm}" 
        teacher_advice="수고 하셨습니다." 
        date="${setDate()}"
        result_mode="point" 
        reward="${rwdPoint}" 
        time="${timTime ? timeRef.current : ''}"
        user_info='{"uid":"${uid}","id":"${uid}","name":"${uid}"}'
        api_host="${api_host}"
        upload_api_host="${upload_api_host}"
        file_host="${file_host}" 
        is_hint="${props.hintOnOff}"
        status="${status}"
    </kv-assessment-container>`;

    React.useEffect(() => {
        if (isInitTime) {
            // test;
            const selector = document.getElementsByTagName('kv-assessment-container');
            const viewerEventListener = (e: any) => {
                common.log('[NAVI]평가 뷰어 이벤트 수신', e);
                if (eventListener) {
                    eventListener(e);
                }
            };

            const linkToPageEventListenser = async (e: any) => {
                const result = await viewer.linkToPageEventListenser(e);

                // if (result) {
                //     if (result.gbCd === 2) {
                //         if (persist.sGubun === 'T') {
                //             await HwkStore.getInfo(result.id);
                //             navigate(AppRoutes.ClassMaterialsHwkGuide.path);
                //         } else if (persist.sGubun === 'S') {
                //             const info = await StntHwkStore.initHomework(result.id)
                //             if (info) {
                //                 if (info.taskSttsCd == 1) {
                //                     navigate(AppRoutes.HomeworkBeforeOpen.path)
                //                 } else {
                //                     navigate(AppRoutes.HomeworkAfterOpen.path)
                //                 }
                //             }
                //         }
                //     } else {
                //         if (persist.sGubun === 'T') {
                //             await EvalStore.getInfo(result.id);
                //             navigate(AppRoutes.ClassMaterialsEvalGuide.path);
                //         } else if (persist.sGubun === 'S') {
                //             const info = await StntEvalStore.initEvaluation(result.id);
                //             if (info) {
                //                 if (info.lesnEvalAt == 'Y') {
                //                     // 수업 중 평가
                //                     if (info.evlSttsCd < 3) {
                //                         navigate(AppRoutes.EvaluationBeforeOpen.path);
                //                     } else {
                //                         navigate(AppRoutes.EvaluationAfterOpen.path);
                //                     }
                //                 } else {
                //                     // 방과 후 평가
                //                     // const isStarted = datetime.isCurrentlyLate(info.evlPrgDt);
                //                     if (info.evlSttsCd == 1) {
                //                         navigate(AppRoutes.EvaluationBeforeOpen.path);
                //                     } else {
                //                         navigate(AppRoutes.EvaluationAfterOpen.path);
                //                     }
                //                 }
                //             }
                //         }
                //     }
                // }
            };

            if (selector && selector[0]) {
                selector[0].addEventListener('viewer-goto-idx', viewerEventListener); // 문제 이동
                selector[0].addEventListener('question-solvecheck', viewerEventListener); // 답안 입력
                selector[0].addEventListener('update-userposition', viewerEventListener);
                selector[0].addEventListener('upload-user-report', viewerEventListener); // 제출 하기
                selector[0].addEventListener('upload-singleuser-report', viewerEventListener); // 아티클(문제) 이동시 결과 반환
                selector[0].addEventListener('upload-peer-report', viewerEventListener);
                selector[0].addEventListener('fullscreen-popup', viewerEventListener);
                selector[0].addEventListener('teachers-assessment-popup', viewerEventListener); // 팝업 요청('timetable'시간추가팝업 | 'monitering' 실시간모니터링| 'exit'나가기)
                selector[0].addEventListener('end-assessment', viewerEventListener);
                selector[0].addEventListener('assessment-reported-answers', viewerEventListener);
                selector[0].addEventListener('loading-status', viewerEventListener);
                selector[0].addEventListener('loading-modal', viewerEventListener);
                selector[0].addEventListener('textbook-module-answer-load', viewerEventListener); // (교사) 정답 보기

                // 손글씨
                selector[0].addEventListener('textbook-handprinting-load', viewerEventListener); // 손글씨 조회
                selector[0].addEventListener('textbook-handprinting-save', viewerEventListener); // 손글씨 저장

                // 자기 동료 평가
                selector[0].addEventListener('self-peer-evaluation-save', viewerEventListener); // 자기 동료 평가 제출
                selector[0].addEventListener('get-peer-info', viewerEventListener); // 동료 평가 대상 정보 요청

                // aitutor 아티클 정보 전달
                selector[0].addEventListener('send-current-location-info', viewerEventListener);
                selector[0].addEventListener('send-aitutor-end', viewerEventListener);

                // 외부 링크
                selector[0].addEventListener('link-to-page', linkToPageEventListenser);
            }
        }
    }, [isInitTime]);

    React.useEffect(() => {
        initTime();
        return () => {
            setIsInitTime(false);
            timeRef.current = '';
        };
    }, []);

    return (
        <>
            <div style={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: kvAssessmentContainer,
                    }}
                ></div>
            </div>
        </>
    );
};

type KvAssessmentViewMsgType =
    | 'update-userdata'
    | 'receive-user-report'
    | 'notify-user-report'
    | 'assessment-add-time'
    | 'update-peer-report-template' // 자기동료 평가 정보
    | 'notify-self-peer-evaluation-' // 자기동료 평가 저장 결과
    | 'update-peer-info' // 동료 평가 대상 정보
    | 'notify-textbook-handprinting-load' // 손글씨 조회 결과
    | 'notify-textbook-handprinting-save' // 손글씨 저장 결과
    | 'notify-aitutor-help-article'; // AI 튜터 사용 여부

export const sendToKvAssessmentView = (data: any, type: KvAssessmentViewMsgType, key?: string) => {
    viewer.sendToElement('kv-assessment-container', data, type, key);
};
export default KvAssessmentView;
